import React, { useState, useEffect } from 'react';
import ConfirmationModal from '../../../../components/Modal/ConfirmationModal';

const NDA_REMINDER_WINDOW_DAYS = 14;

export interface BuyerNdaReminderPopupProps {
    open: boolean;
    onClose: () => void;
    onNavigateToAgreements: () => void;
    ndaPostedAt: string | null;
}

export const BuyerNdaReminderPopup = (props: BuyerNdaReminderPopupProps) => {
    const [isVisible, setIsVisible] = useState(props.open);

    useEffect(() => {
        setIsVisible(props.open);
    }, [props.open]);

    useEffect(() => {
        if (!isVisible && props.open) {
            props.onClose();
        }
    }, [isVisible]);

    const calculateDaysLeft = (): number => {
        if (!props.ndaPostedAt) {
            return 0;
        }
        const postedDate = new Date(props.ndaPostedAt);
        const today = new Date();
        const daysSincePosted = Math.floor(
            (today.getTime() - postedDate.getTime()) / (1000 * 60 * 60 * 24)
        );
        return NDA_REMINDER_WINDOW_DAYS - daysSincePosted;
    };

    const daysLeft = calculateDaysLeft();
    const isWithinWindow = daysLeft > 0;

    const renderConfirmationText = () => (
        <>
            <p>
                {isWithinWindow ? (
                    <>
                        You will have <strong>{daysLeft} days</strong> to sign the new
                        agreement. If it is not executed within that time, you will no
                        longer be able to view any opportunities for which you are not
                        currently engaged, including both new and existing listings.
                    </>
                ) : (
                    <>
                        Please execute the new agreement. Until signed, you will not be
                        able to view any opportunities for which you are not currently
                        engaged, including both new and existing listings.
                    </>
                )}
            </p>
            <p>
                For your convenience, a <strong>redline version</strong> showing the
                changes from the previous NDA is available in the{' '}
                <strong>&ldquo;Connect Agreements&rdquo;</strong> tab.
            </p>
        </>
    );

    return (
        <ConfirmationModal
            isVisible={isVisible}
            setIsVisible={setIsVisible}
            header="New Connect NDA ready for Review & Execution"
            confirmationText={renderConfirmationText()}
            onConfirm={props.onNavigateToAgreements}
            onCancel={props.onClose}
            nextButtonText="Review & Execute Document"
            cancelButtonText="Close"
        />
    );
};
